export default "__VITE_ASSET__CGLXDres__"